var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubmitApplication(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6659 13.3802V23.3802C36.6659 25.8802 35.8325 27.9636 34.3658 29.4302C32.9158 30.8802 30.8325 31.7135 28.3325 31.7135V35.2636C28.3325 36.5969 26.8492 37.3969 25.7492 36.6636L18.3325 31.7135H14.7992C14.9325 31.2135 14.9992 30.6969 14.9992 30.1636C14.9992 28.4636 14.3492 26.8969 13.2825 25.7136C12.0825 24.3469 10.2992 23.4969 8.33252 23.4969C6.46585 23.4969 4.76586 24.2636 3.54919 25.5136C3.39919 24.8469 3.33252 24.1302 3.33252 23.3802V13.3802C3.33252 8.38021 6.66585 5.04688 11.6659 5.04688H28.3325C33.3325 5.04688 36.6659 8.38021 36.6659 13.3802Z",
    stroke: "#081E54",
    strokeWidth: 1.57895,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0008 30.1628C15.0008 30.6961 14.9342 31.2127 14.8008 31.7127C14.6508 32.3794 14.3842 33.0294 14.0342 33.5961C12.8842 35.5294 10.7675 36.8294 8.33415 36.8294C6.61748 36.8294 5.06747 36.1794 3.90081 35.1127C3.40081 34.6794 2.96746 34.1628 2.63412 33.5961C2.01746 32.5961 1.66748 31.4128 1.66748 30.1628C1.66748 28.3628 2.38416 26.7128 3.55082 25.5128C4.76749 24.2628 6.46748 23.4961 8.33415 23.4961C10.3008 23.4961 12.0841 24.3461 13.2841 25.7128C14.3508 26.8961 15.0008 28.4628 15.0008 30.1628Z",
    fill: "#A020FF",
    stroke: "#A020FF",
    strokeWidth: 2.10526,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8162 30.1328H5.84961",
    stroke: "white",
    strokeWidth: 1.57895,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 27.6992V32.6825",
    stroke: "white",
    strokeWidth: 1.57895,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8569 15.2812H27.1426",
    stroke: "#1552E8",
    strokeWidth: 1.47368,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8569 18.8555H27.1426",
    stroke: "#1552E8",
    strokeWidth: 1.47368,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitApplication);
export default __webpack_public_path__ + "static/media/SubmitApplication.49c64ec462833cf1e926eba7aa15e45f.svg";
export { ForwardRef as ReactComponent };